import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const incidentIoWeb: PluginWebManifest = {
  orgSetupComponent: {
    componentPath: '@reflex/plugin-incident-io/web/IncidentIoPage',
    label: 'Add an incident.io API key and webhook signing secret for this org.',
  },
  flowTriggerRenderers: [
    {
      triggerType: 'incident_io_incident',
      label: 'incident.io incident',
      icon: 'ShieldAlert',
      componentPath: '@reflex/plugin-incident-io/web/IncidentIoFlowTriggerSummary',
    },
  ],
  marketingPreviews: [
    {
      id: 'incident-io-page',
      label: 'incident.io integration page',
      description:
        'Sample data showing the connection card, live incidents, and recent webhook deliveries.',
      surface: 'panel',
      componentPath: '@reflex/plugin-incident-io/web/IncidentIoPagePreview',
    },
  ],
};
